import React from 'react';
import UnderConstructionBar from './UnderConstructionBar';
import UnderConstructionLogo from './UnderConstructionLogo';
import './UnderConstruction.css';

const UnderConstruction = () => {
    return (
        <div className="UnderConstruction">
            <div className="UnderConstruction-left">
                <UnderConstructionLogo />
            </div>
            <div className="UnderConstruction-center">
                <UnderConstructionBar />
            </div>
            <div className="UnderConstruction-right">
                <UnderConstructionLogo />
            </div>
        </div>
    );
};

export default UnderConstruction;



// WEBPACK FOOTER //
// ./src/components/UnderConstruction/index.jsx